module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yu-scroll_view",
    attrs: {
      "data-com": "YuScrollView"
    },
    on: {
      "&scroll": function($event) {
        _vm.fnScroll($event)
      },
      "&touchstart": function($event) {
        _vm.fnTouchstart($event)
      },
      "&touchend": function($event) {
        _vm.fnTouchend($event)
      }
    }
  }, [_c('div', {
    staticClass: "yu-scroll_view-cont"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58582f81","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/YouUI/View/ScrollView.vue
// module id = 288
// module chunks = 0